import { SET_CLIENT_DATA } from '../actions/types'

const initialState = {}

const clientDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_DATA:
      return action.payload
    default:
      return state
  }
}

export default clientDataReducer
